import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

import { CheckIcon } from '@radix-ui/react-icons';
import { styled } from '@stitches/react';
import Label from '../label';
import { COLORS } from '@lib/constants';

const StyledIndicator = styled(CheckboxPrimitive.Indicator, {
  color: COLORS.primary2
});

export const CheckboxIndicator = () => (
  <StyledIndicator>
    <CheckIcon />
  </StyledIndicator>
);

type CheckBoxProps = {
  name: string | number;
  label: string;
  description?: string;
  value?: string;
  checked: boolean;
  onChange?: (arg0: any) => void;
  onClick?: (arg0: any) => void;
  className?: string;
  placeholder?: string;
};

const CheckBox = ({
  name,
  label,
  description,
  value,
  checked = false,
  onChange,
  onClick,
  className
}: CheckBoxProps) => {
  return (
    <>
      <div className="flex items-center">
        <div className="flex items-center h-5">
          <input
            id={name.toString()}
            name={name.toString()}
            type="checkbox"
            checked={checked}
            onChange={onChange}
            value={value}
            className={`w-5 h-5 text-primary border-gray-300 rounded focus:ring-transparent cursor-pointer ${
              !className ? '' : className
            }`}
            onClick={onClick}
          />
        </div>
        <div className="flex items-center ml-1 text-xs">
          <Label
            htmlFor={name.toString()}
            className="ml-1 font-normal text-neutral-800 cursor-pointer"
          >
            {label}
          </Label>
          <p className="ml-2 text-gray-500 ">{description}</p>
        </div>
      </div>
    </>
  );
};

export default CheckBox;
